module.exports = __webpack_public_path__ + "static/img/aj.38b59ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aj.png
// module id = N5H5
// module chunks = 1